export default __webpack_public_path__ + "media/titles/title_1_locale_da-2094d4ba.png";